module.exports = __webpack_public_path__ + "media/images/ilustration-5dd773bb5e31bd24c3990df1de9d004c.png";